import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Button, Heading, OverlayArrow, Text, Tooltip as TooltipAria, TooltipTrigger } from "react-aria-components";
import { icon } from "../icon.css.js";
import { HelpCircle } from "../icons/line.js";
import * as styles from "./Tooltip.css.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const BaseTooltip = (t0, ref) => {
  const $ = _c(28);
  let children;
  let props;
  let supportingText;
  let t1;
  let t2;
  let text;
  if ($[0] !== t0) {
    ({
      text,
      supportingText,
      children,
      theme: t1,
      arrow: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = supportingText;
    $[4] = t1;
    $[5] = t2;
    $[6] = text;
  } else {
    children = $[1];
    props = $[2];
    supportingText = $[3];
    t1 = $[4];
    t2 = $[5];
    text = $[6];
  }
  const theme = t1 === undefined ? "light" : t1;
  const arrow = t2 === undefined ? false : t2;
  let isOpen;
  let tooltipProps;
  if ($[7] !== props) {
    ({
      isOpen,
      ...tooltipProps
    } = props);
    $[7] = props;
    $[8] = isOpen;
    $[9] = tooltipProps;
  } else {
    isOpen = $[8];
    tooltipProps = $[9];
  }
  let t3;
  if ($[10] !== theme) {
    t3 = styles.tooltip({
      theme
    });
    $[10] = theme;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== arrow || $[13] !== theme) {
    t4 = arrow && /*#__PURE__*/_jsx(OverlayArrow, {
      className: styles.overlayArrow({
        theme
      }),
      children: /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "9",
        viewBox: "0 0 17 9",
        className: styles.overlayArrowSvg,
        children: /*#__PURE__*/_jsx("path", {
          d: "M14.5711.485289c.8909 0 1.337 1.077141.7071 1.707111L9.20711 8.26347c-.39053.39053-1.02369.39053-1.41422 0L1.72183 2.1924c-.62996-.62997-.1838-1.707111.70711-1.707111H14.5711Z"
        })
      })
    });
    $[12] = arrow;
    $[13] = theme;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== supportingText || $[16] !== text) {
    t5 = supportingText == null ? /*#__PURE__*/_jsx(Text, {
      slot: "description",
      className: styles.tooltipTextHeader,
      children: text
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Heading, {
        slot: "header",
        className: styles.tooltipTextHeader,
        children: text
      }), /*#__PURE__*/_jsx(Text, {
        slot: "description",
        className: styles.tooltipTextSupporting,
        children: supportingText
      })]
    });
    $[15] = supportingText;
    $[16] = text;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== ref || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== tooltipProps) {
    t6 = /*#__PURE__*/_jsxs(TooltipAria, {
      offset: styles.tooltipGap + styles.overlayArrowHeight,
      className: t3,
      ...tooltipProps,
      ref: ref,
      children: [t4, t5]
    });
    $[18] = ref;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = tooltipProps;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== children || $[25] !== isOpen || $[26] !== t6) {
    t7 = /*#__PURE__*/_jsxs(TooltipTrigger, {
      isOpen: isOpen,
      delay: 0,
      children: [children, t6]
    });
    $[24] = children;
    $[25] = isOpen;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
};
export const Tooltip = /*#__PURE__*/React.forwardRef(BaseTooltip);
export const TooltipIcon = t0 => {
  const $ = _c(10);
  const {
    color,
    size: t1
  } = t0;
  const size = t1 === undefined ? "s" : t1;
  let t2;
  if ($[0] !== color || $[1] !== size) {
    t2 = styles.helpIcon({
      size,
      color
    });
    $[0] = color;
    $[1] = size;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== size) {
    t3 = icon({
      size
    });
    $[3] = size;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = /*#__PURE__*/_jsx(HelpCircle, {
      className: t3
    });
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = /*#__PURE__*/_jsx(Button, {
      className: t2,
      children: t4
    });
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
//# sourceMappingURL=Tooltip.js.map